import React from 'react';
import 'whatwg-fetch';

export default class InputFormAssociated extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (!this.props.entityAssociated) {
      return null;
    }

    return (
      <div className='form-group'>
        <label>Associé à</label>
        <select
          name='entityAssociated'
          value={this.props.entityAssociated.id}
          onChange={this.handleInputChange}
          className='form-control'
          disabled
        >
          <option value={this.props.entityAssociated.id}>{this.props.entityAssociated.name}</option>
        </select>
      </div>
    );
  }
}
